<div class="modal-body">
  <div class="card-custom">
    <div class="instructions">
      <label for=""
        >* Add columns from the left side list to display on results.</label
      >
      <label for=""
        >* The order of selected columns can be rearranged by dragging and
        dropping tiles up or down.</label
      >
    </div>
    <div class="sc-head">
      <!-- <select class="form-control form-control-sm" [(ngModel)]="dataSource" (change)="getSelectedItems()">
                <option value="" [disabled]="true">--Select Type--</option>
                <option value="golden profile">Sanofi Profile</option>
                <option value="cross reference">Cross reference data</option>
            </select> -->
    </div>
    <div class="main">
      <div class="all-items">
        <label for="all_columns" class="list-title">{{constants.COLUMN_SECTION_POP_UP.ALL_COLUMN}}</label>
        <div class="all-list-vertical">
          <div *ngFor="let item of ItemsBySource">
            <div class="item-tba">
              <label for="column_name" class="column-name">{{
                item.ui_column_name
              }}</label>
              <button
                class="btn btn-sm btn-primary btn-add"
                (click)="addItem(item, item.db_column_name)"
                [disabled]="isItemAdded(item.db_column_name)"
              >
                {{
                  isItemAdded(item.db_column_name) === true ? "Added" :  "Add"
                }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="selected-items">
        <label for="selected_columns" class="list-title"
          >{{constants.COLUMN_SECTION_POP_UP.SELECTED_COLUMNS}}</label
        >
        <div
          cdkDropList
          [cdkDropListData]="selectedItemsArray"
          class="chip-list-vertical"
          (cdkDropListDropped)="drop($event)"
        >
          <div
            *ngFor="let item of selectedItemsArray; let i = index"
            cdkDrag
            class="chip-row"
          >
            <mat-chip
              [removable]="true"
              (removed)="removeItem(i)"
              class="mat-chip-custom"
              color="primary"
              selected
            >
              {{ item.ui_column_name }}
              <button matChipRemove>&times;</button>
            </mat-chip>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="page-bottom">
    <button
      type="button"
      class="btn btn-sm btn-primary btn-save"
      (click)="saveColumns()"
      [disabled]="dataSource === '' || selectedItemsArray.length === 0"
    >
      {{constants.SAVE}}
    </button>
    <button type="button" class="btn btn-sm btn-danger" (click)="closeModal()">
      {{constants.CLOSE}}
    </button>
  </div>
</div>
